import styles from './UserName.module.css';

const UserName = ({ username }) => {
  return <span className={styles.username}>{username}</span>;
};

export default UserName;
